import { SupabaseServiceView } from "../../../server/supabase/base-supabase-service";
import { Database } from "../../../server/supabase/types/database-definitions";


export type UnfoundConnection = Database['public']['Views']['unfound_connection_data']['Row'];
 

export class SupabaseUnfoundConnectionsService extends SupabaseServiceView<'unfound_connection_data'>{
    table = 'unfound_connection_data' as const;
}